import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Heart, Home } from "lucide-react";
import { useI18n } from "../context/I18nContext";

export default function ThankYou() {
  const { state } = useLocation();
  const { t } = useI18n();
  return (
    <div className="min-h-[70vh] bg-ivory grid place-items-center" data-testid="thanks-page">
      <div className="max-w-2xl px-5 text-center">
        <div className="w-20 h-20 rounded-full bg-gold grid place-items-center mx-auto shadow-xl">
          <Heart className="text-deep-blue fill-deep-blue" size={36}/>
        </div>
        <h1 className="font-display text-5xl sm:text-6xl text-deep-blue mt-8">{t("pages.thanks.title")}</h1>
        <p className="font-display italic text-warm-orange text-2xl mt-4">« {t("pages.thanks.quote")} »</p>
        {state?.amount && (
          <p className="text-deep-blue/70 mt-6">Votre engagement de <b>{state.amount}€</b> ({state.freq}) en faveur de <i>{state.program}</i> est bien enregistré. Un email de confirmation avec les instructions de paiement ({state.method === "paypal" ? "PayPal" : "virement bancaire"}) vous a été envoyé.</p>
        )}
        {state?.type === "volunteer" && <p className="text-deep-blue/70 mt-6">Votre candidature de bénévole est bien reçue. Nous vous recontacterons.</p>}
        <Link to="/" className="btn-ghost-blue mt-10 inline-flex items-center gap-2 px-8 py-3 rounded-full font-semibold" data-testid="thanks-home">
          <Home size={16}/> {t("pages.thanks.home")}
        </Link>
      </div>
    </div>
  );
}
